import { render } from "./QrImagePage.vue?vue&type=template&id=05afcf72"
import script from "./QrImagePage.vue?vue&type=script&lang=js"
export * from "./QrImagePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__